import '../css/Footer.scss'

export default function Footer({absolute}) {
    const footerClass = absolute ? 'footerAbsolute' : 'footerRelative'
    return (
        <>
            <footer className={footerClass}>
                <p>
                    Data API by <a href="https://developer.spotify.com/">Spotify</a>, Website designed and developed by <a href="https://www.linkedin.com/in/ruben-schrurs-03502214b/">Ruben Schrurs</a>
                </p>
            </footer>
        </>
    )
}